Namespace 'Customer.Filters'

class Customer.Filters.DatePickerCardView extends Backbone.View
  className: 'filter-date-container filter-field-container'

  initialize: ({filter}) ->
    @filter = filter

  render: ->
    dateRange = @filter._queryWithDefaults().get('query').date_range
    @dateFilterView ||= new Customer.Filters.DateFilter({dateRange: dateRange})
    @$el.empty().append(@dateFilterView.render().el)
    @

  getDateRange: =>
    @dateFilterView.getDateRange()
